const styleSheet = () => ({
  container: {
    display: 'inline-block',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    top: '50%',
    fontSize: '20px',
  },
});

export default styleSheet;
